import styled from 'styled-components';

export const StyledCreditHolder = styled.div`
  width: 100%;

  .btn-credits {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    overflow: hidden;
    padding: 10px;
    border-radius: 12px;
    background: transparent;
    border: none;
    cursor: pointer;

    &:hover {
      background: rgba(39, 131, 236, 0.05);
    }

    &.active {
      background: rgba(39, 131, 236, 0.05);

      .label,
      .icon {
        filter: invert(37%) sepia(96%) saturate(1613%) hue-rotate(196deg) brightness(97%) contrast(90%);
      }
    }

    .label {
      display: block;
      flex-shrink: 0;
      transition: 0.3s;
      text-align: left;
      transform: translateX(10px);
      color: #4c6484;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      white-space: nowrap;

      .aside-active & {
        transform: translateX(0);
      }
    }

    .icon {
      width: 20px;
      height: 19px;
      flex-shrink: 0;
      margin-left: 2px;
    }
  }
`;

export const StyledCreditsDropdown = styled.div`
  position: fixed;
  top: var(--credits-dropdown-top, 0);
  left: var(--credits-dropdown-left, 100px);
  z-index: 150;
  width: 330px;
  overflow: visible;
  border-radius: 10px;
  background: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.06);

  &::before {
    content: '';
    position: absolute;
    top: var(--credits-arrow-top, 50%);
    left: -20px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 16px solid transparent;
    border-right: 20px solid var(--white);
    border-bottom: 16px solid transparent;
    filter: drop-shadow(-1px 0 0 rgba(0, 0, 0, 0.08));
    z-index: 1;
  }
`;

export const StyledCreditsDropdownInner = styled.div`
  max-height: calc(100vh - 24px);
  overflow-y: auto;
  padding: 0 0 8px;
  border-radius: inherit;
`;

export const StyledCreditsBarHolder = styled.div`
  padding: 12px 18px;

  &:not(:last-child) {
    border-bottom: 1px solid #efefef;
  }
`;

export const StyledCreditsHeadingHolder = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 5px;

  .icon-box {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
  }
`;

export const StyledCreditsHeading = styled.span`
  display: block;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: #1c1c1c;
`;

export const StyledCreditBarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledCreditProgress = styled.div`
  flex-grow: 1;
  height: 4px;
  min-width: 60px;
  border-radius: 50px;
  position: relative;
  overflow: hidden;
  background: #d9d9d9;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: var(--value, 0%);
    max-width: 100%;
    background: #2783ec;
    border-radius: 50px;
    z-index: 1;
  }
`;

export const StyledCreditsWrap = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;

  .remaining {
    font-weight: 600;
    color: #2f2f2f;
  }

  .total {
    font-weight: 400;
    color: #7f8594;
  }
`;
